/* eslint-disable max-len */
import { Button, FormHelperText, Grid, IconButton, InputAdornment, Stack, TextField, Typography } from '@mui/material';
import React, { useContext, useState } from 'react';
import { IoIosAdd } from 'react-icons/io';
import { MdClear } from 'react-icons/md';
import { RiDeleteBinLine } from 'react-icons/ri';
import { LanguageContext } from '../../../../../../../libs/Context';
import CustomSwitch from '../../../../../../BusinessSettings/Components/BussinessCertification/components/CustomSwitch';

const QuestionBox = (props) =>
{
	const { q, qIndex, showDelete, errorObj, questions, setQuestions, status } = props;
	const { language } = useContext(LanguageContext);

	const handleDeleteQuestion = (index) =>
	{
		if (questions.length > 1)
		{
			const newQuestions = questions.filter((_, qInd) => qInd !== index);

			setQuestions(newQuestions);
		}
	};

	const handleQuestionChange = (event) =>
	{
		const newQuestions = JSON.parse(JSON.stringify(questions));

		if (questions[qIndex].question !== event.target.value.replace(/\s+/g, ' '))
		{
			newQuestions[qIndex] = { ...newQuestions[qIndex], question: event.target.value.replace(/\s+/g, ' ') };
			setQuestions(newQuestions);
		}
	};

	const handleAddOption = (questionIndex) =>
	{
		const newQuestions = JSON.parse(JSON.stringify(questions));

		if (newQuestions[questionIndex].options.length < 6)
		{
			newQuestions[questionIndex].options.push('');
		}
		setQuestions(newQuestions);
	};

	const handleDeleteOption = (questionIndex, optionIndex) =>
	{
		const newQuestions = JSON.parse(JSON.stringify(questions));

		if (newQuestions[questionIndex].options.length > 1)
		{
			newQuestions[questionIndex].options.splice(optionIndex, 1);
			if (newQuestions[questionIndex].options?.length === 1)
			{
				newQuestions[questionIndex].questionType = 'single';
			}

			if (errorObj[questionIndex]?.duplicateOptionErrMsg)
			{
				delete errorObj[questionIndex].duplicateOptionErrMsg;
				delete errorObj[questionIndex].duplicateOptionIndex;
			}
			if (errorObj[questionIndex] && errorObj[questionIndex].OptionErrMsg && !newQuestions[questionIndex].options.some((opt) => opt.trim() === ''))
			{
				delete errorObj[questionIndex].OptionErrMsg;
			}
			setQuestions(newQuestions);
		}
	};

	const handleOptionChange = (optionIndex, event) =>
	{
		const value = event.target.value.trimStart();
		const newQuestions = JSON.parse(JSON.stringify(questions));
		const currentOptions = newQuestions[qIndex].options;

		const isDuplicate = currentOptions.some(
			(opt, idx) => idx !== optionIndex && opt.trim().toLowerCase() === value.trim().toLowerCase()
		);

		setQuestions(newQuestions);
		if (!errorObj[qIndex]) errorObj[qIndex] = {};

		if (isDuplicate)
		{
			errorObj[qIndex].duplicateOptionErrMsg = 'Duplicate options are not allowed';
			errorObj[qIndex].duplicateOptionIndex = optionIndex;
		}
		else
		{
			delete errorObj[qIndex].duplicateOptionErrMsg;
			delete errorObj[qIndex].duplicateOptionIndex;
		}

		newQuestions[qIndex].options[optionIndex] = value;
	};

	const handleToggel = (ind) =>
	{
		const newQuestions = JSON.parse(JSON.stringify(questions));

		newQuestions[ind].questionType = newQuestions[ind].questionType === 'single' ? 'multi' : 'single';
		setQuestions(newQuestions);
	};

	const isNewQuestion = q.question === '';
	const isAnyFieldEmpty = q.options.some((item) => item.trim() === '');

	return (
		<Stack sx={{ padding: '16px 12px', margin: '16px 0px', border: '1px solid #CFD1D4', borderRadius: 'var(--pixel8)' }} key={qIndex}>
			<span id={`questionNumb_${qIndex}`}/>
			<Grid item xs={12} pb='var(--pixel16)' >
				<Stack direction={'row'} justifyContent='space-between'>
					<Typography sx={{ paddingBottom: 'var(--pixel4)' }}>{qIndex + 1}. {language?.question}</Typography>
					{status === 'create' && showDelete &&
					<IconButton onClick={() => handleDeleteQuestion(qIndex)}>
						<RiDeleteBinLine fontSize='var(--pixel20)' />
					</IconButton>}
				</Stack>
				<Stack pt='var(--pixel8)'>
					<TextField autoFocus={isNewQuestion} placeholder={language.enterUrQuestion} onChange={handleQuestionChange} value={q.question} size='small' id='Enter your question' />
				</Stack>
				{errorObj[qIndex]?.questionErrMsg && (
					<FormHelperText id='txtEmail-error' className='errorTxt'>
						{errorObj[qIndex]?.questionErrMsg}
					</FormHelperText>
				)}
			</Grid>
			<Grid item sm={12} pb='var(--pixel8)'>
				<Stack direction={'column'}>
					<Typography sx={{ paddingBottom: 'var(--pixel4)' }}>{language.options}</Typography>
					{q.options.map((option, index) => (
						<>
							<Stack
								key={index}
								direction='row'
								spacing={2}
								sx={{ paddingBottom: 'var(--pixel8)' }}
								alignItems='center'
							>
								<TextField
									placeholder={`option  ${index + 1}`}
									id={`+Add${index}`}
									size='small'
									autoFocus={!isNewQuestion && option === ''}
									fullWidth
									value={option}
									onChange={(e) => handleOptionChange(index, e)}
									InputProps={{
										endAdornment : q.options.length > 1 && (
											<InputAdornment position='end' onClick={() => handleDeleteOption(qIndex, index)}>
												<MdClear cursor={'pointer'} fontSize='var(--pixel20)' />
											</InputAdornment>
										)
									}}
								/>
							</Stack>
							{(errorObj[qIndex]?.OptionErrMsg && index === 0) || (errorObj[qIndex]?.duplicateOptionErrMsg && errorObj[qIndex]?.duplicateOptionIndex === index)
								? (
									<FormHelperText id='txtEmail-error' className='errorTxt'>
										{index === 0 ? errorObj[qIndex]?.OptionErrMsg : errorObj[qIndex]?.duplicateOptionErrMsg}
									</FormHelperText>
								)
								: null}

						</>
					))}
				</Stack>
			</Grid>
			<Grid container justifyContent='space-between' direction='row'>
				<Grid item>
					<Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
						<Typography variant='subtitle1' pr='var(--pixel8)'>{language?.allowmultipleAnswers}</Typography>
						<CustomSwitch
							toggleEnabled={q?.questionType === 'multi'}
							from={'createContract'}
							disabledCheck={q?.options?.length < 2}
							handleToggleChange={() => q?.options?.length >= 2 && handleToggel(qIndex)}
						/>
					</Stack>
				</Grid>
				<Grid item>
					<Button
						variant='outlined'
						sx={{ textTransform: 'capitalize' }}
						startIcon={<IoIosAdd />}
						onClick={() => handleAddOption(qIndex)}
						disabled={isAnyFieldEmpty || q.options.length >= 6}
					>
						{language.add}
					</Button>
				</Grid>
			</Grid>
		</Stack>
	);
};

export default QuestionBox;